import React, { useEffect, useState } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import {
    CButton, CCard, CCardBody, CCardHeader
} from '@coreui/react';

import { apiClient } from 'services/Api';
import { jwtDecode } from 'jwt-decode';
import DataTableComponent from 'components/DataTableComponent';
import AlertNotification, { triggerAlert } from 'components/globals/AlertNotification';
import RecordDetailOffcanvas from 'components/RecordDetailOffcanvas';

const DepartmentList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [departments, setDepartments] = useState([]);
    const [previewDepartment, setPreviewDepartment] = useState(null);

    const token = localStorage.getItem('access_token');
    const decodedToken = token ? jwtDecode(token) : {};
    const is_manager = !!decodedToken?.is_manager;
    const is_staff = !!decodedToken?.is_staff;

    useEffect(() => {
        const load = async () => {
            try {
                // minimal list (id, name). Pass ?extended=1 if you want member details/counts.
                const res = await apiClient.get('/departments/');
                setDepartments(res.data);
                setPreviewDepartment((current) => current
                    ? res.data.find((department) => department.id === current.id) || null
                    : null);
            } catch (err) {
                console.error('Error fetching departments:', err);
            }
        };
        load();
    }, [location.pathname]);

    const handleDelete = async (id) => {
        try {
            await apiClient.delete(`/departments/${id}/`);
            setDepartments((prev) => prev.filter((d) => d.id !== id));
            setPreviewDepartment((current) => current?.id === id ? null : current);
            triggerAlert('Departamento eliminado com sucesso!', 'success');
        } catch (err) {
            console.error('Error deleting department:', err);
            triggerAlert('Erro ao eliminar departamento', 'error');
        }
    };

    const columns = [
        { name: 'Nome', selector: (row) => row.name, sortable: true, className: 'text-center' },
    ];

    return (
        <>
            <AlertNotification />
            <CCard>
                <CCardHeader className="d-flex justify-content-between align-items-center">
                    <h3 className="mb-0">Departamentos</h3>
                    <div className="d-flex gap-2">
                        <Link to="/alocacao-departamentos">
                            <CButton color="primary" className="text-white">
                                Gerir alocação
                            </CButton>
                        </Link>

                        <Link to="/departamentos/new">
                            <CButton color="info" className="text-white">
                                Novo Departamento
                            </CButton>
                        </Link>
                    </div>
                </CCardHeader>
                <CCardBody>
                    <DataTableComponent columns={columns} data={departments} onRowClicked={setPreviewDepartment} />
                </CCardBody>
            </CCard>
            <RecordDetailOffcanvas
                record={previewDepartment}
                onHide={() => setPreviewDepartment(null)}
                title="Departamento"
                subtitle={previewDepartment?.name}
                fields={previewDepartment ? [
                    { label: 'Nome', value: previewDepartment.name },
                ] : []}
                headerActions={previewDepartment && <>
                    <CButton color="info" variant="outline" size="sm" onClick={() => navigate(`/departamentos/${previewDepartment.id}`)}>
                        Ver/Editar
                    </CButton>
                    {(is_manager || is_staff) && !previewDepartment.is_direction && (
                        <CButton color="danger" size="sm" className="text-white" onClick={() => handleDelete(previewDepartment.id)}>
                            Eliminar
                        </CButton>
                    )}
                </>}
            />
        </>
    );
};

export default DepartmentList;
